import HmacSHA256 from 'crypto-js/hmac-sha256';

export const generateApiSignature = (
  token: string,
  secret: string,
  data: { [key: string]: string },
  url: string,
  requestMethod: string,
): string => {
  const sorted: { [key: string]: string } = {},
    a = [];
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      a.push(key);
    }
  }
  a.sort();
  for (const element of a) {
    sorted[element] = data[element];
  }
  let longStr = `${requestMethod}|${url}\n`;
  for (const k in sorted) {
    if (Object.prototype.hasOwnProperty.call(data, k)) {
      longStr += k + sorted[k];
    }
  }
  longStr += token;
  const hash = HmacSHA256(longStr.trim(), secret);
  return btoa(hash.toString());
};
